interface Segment<T extends string> {
  readonly value: T;
  readonly label: string;
}

interface SegmentedControlProps<T extends string> {
  readonly label: string;
  readonly value: T;
  readonly options: readonly Segment<T>[];
  readonly onChange: (value: T) => void;
  readonly compact?: boolean;
}

export function SegmentedControl<T extends string>({ label, value, options, onChange, compact = false }: SegmentedControlProps<T>) {
  return (
    <div className={`segmented ${compact ? 'segmented--compact' : ''}`} role="group" aria-label={label}>
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          className={option.value === value ? 'is-active' : ''}
          aria-pressed={option.value === value}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
